import React from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import AdminDetailedReport from "../pages/AdminDetailedReport";
import StatusHistory from "./StatusHistory";
import UpdateMileage from "./UpdateMileage";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function VehicleSearchTabs(props) {
  const [value, setValue] = React.useState(0);
  const vin = props.vin;
  const isUnground = props.isUnground;
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div>
      {isUnground ? <>
        <TabPanel value={value} index={0}>
            {vin &&
              <AdminDetailedReport
                inspectiondata={props?.inspectiondata}
                vin={vin}
                isUnground = {isUnground}
              />
            }
          </TabPanel>
      </>
        :
        <>
          <AppBar position="fixed" className="topBarAdmin">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
              style={{ marginLeft: "35%" }}
            >
              <Tab label="Vehicle Summary" {...a11yProps(0)} />
              <Tab label="Status History" {...a11yProps(1)} />
              <Tab label="Update Mileage/Price" {...a11yProps(2)} />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            {vin &&
              <AdminDetailedReport
                inspectiondata={props?.inspectiondata}
                vin={vin}
                value={props.hideShow(value)}
              />
            }
          </TabPanel>
          <TabPanel value={value} index={1}>
            <div className="adminTabsSection">
              <StatusHistory
                //  inspectiondata={inspectiondata}
                value={props.hideShow(value)}
                vin={vin}
              />
            </div>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Box className="adminTabsSection">
              <UpdateMileage
                //  inspectiondata={inspectiondata}
                onGetConditionVehicleDetails={props.onGetConditionVehicleDetails}
                value={props.hideShow(value)} vin={vin} />
            </Box>
          </TabPanel>
        </>
      }
    </div>
  );
}
